import { render } from "./EditFaq.vue?vue&type=template&id=f5a80566&ts=true"
import script from "./EditFaq.vue?vue&type=script&lang=ts"
export * from "./EditFaq.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__